import { orchestrationLayerFetcher } from 'util/OL';
import { UPDATE_PRESCRIPTION_MUTATION } from './mutations';
import { trackError } from 'util/error';
import { PrescriptionToSave, UpdatePrescriptionResponse } from './types';

type SavePrescriptionVariables = {
  input: PrescriptionToSave;
}

export const savePrescriptionThroughOL = async (variables: SavePrescriptionVariables) => {
  try {
    return await orchestrationLayerFetcher<UpdatePrescriptionResponse>(UPDATE_PRESCRIPTION_MUTATION, variables);
  } catch (error) {
    trackError(new Error('Could not save prescription through OL'), { error });
    throw error;
  }
};
